import { ColDef, ColGroupDef, GridApi, GridOptions, createGrid } from 'ag-grid-community';
import { IPermissionGrid } from './IPermissionGrid';
import { PanelData } from '../../RolePanelTypes';

export abstract class BasePermissionGrid<TData> implements IPermissionGrid<TData> {
    gridContainer: HTMLElement;
    api: GridApi<TData>;

    abstract id: string;
    abstract gridClass: string;
    protected abstract endpoint: string;
    protected abstract getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[];
    
    protected getOptions(): GridOptions<TData> {
        return {};
    };
    
    destroy(): void {
        this.api.destroy();
        this.api = null;
    }   
    async initOrReload(path: string, panelData: PanelData): Promise<void> {
        if (!this.gridContainer) {
            this.initGridContainer();
        }

        if (this.api) {
            await this.reload(path, panelData);
            return;
        }
        
        this.api = createGrid(this.gridContainer, {
            rowData: await this.buildGridData(path, panelData),
            columnDefs: this.getColumnDefs(),
            suppressCellFocus: true,
            ...(this.getOptions ? this.getOptions() : {}),
        });
    }
    async reload(path: string, panelData: PanelData): Promise<void> {
        this.api.setGridOption('rowData', await this.buildGridData(path, panelData));
        this.api.refreshCells();
    }
    private initGridContainer() {
        this.gridContainer = document.createElement('div');
        this.gridContainer.classList.add(this.gridClass, 'ag-theme-quartz');
    }
    private async buildGridData(path: string, panelData: PanelData): Promise<TData[]> {
        let rowData = await this.fetchGridData(path);
        this.getLocalSyncedData(rowData, panelData);
        return rowData;
    }
    private async fetchGridData(path: string): Promise<TData[]> {
        const response = await fetch(`${this.endpoint}${path}`);
        return await response.json();
    }
    private getLocalSyncedData(rowData: TData[], panelData: PanelData): TData[] {
        if (!panelData) return rowData;

        const permissionObjectRole: TData[] = panelData[this.id];

        if (!permissionObjectRole) return rowData;

        rowData.forEach((row) => {
            const matchingItem = permissionObjectRole.find((objectRole) => (objectRole as any).Id === (row as any).Id);
            if (matchingItem) {
                Object.assign(row, matchingItem);
            }
        });
        return rowData;
    }
}
